module.exports = "img/flags/CO.84ceb1d.png";